'use strict';

var React = require('react');
var Small = require('../../forms/CalendarMonth/Small.js');
var component = require('../../Button/component.js');
var date = require('../../../helpers/date.js');
var filterPopin_styles = require('./filterPopin.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const FilterDatePopin = ({ addToCurrentSort = () => null, calendarProps, defaultOrder = 'date', endColumn = false, filter, id, initialSort, isFilterOpen = false, isFirstCol = false, labelClear = 'Effacer', labelOrderAsc = 'Trier par date croissante', labelOrderDate = 'Tri désactivé', labelOrderDesc = 'Trier par date décroissante', labelOrderTitle = 'Option de tri', locale = 'fr-FR', node = { current: null }, removeFromCurrentSort = () => null, }) => {
    const [month, setMonth] = React.useState(new Date());
    const [filterValue, setFilterValue] = React.useState(initialSort?.filter === filter && initialSort?.value ? initialSort.value : null);
    const [sortValue, setSortValue] = React.useState(initialSort?.filter === filter && initialSort?.order ? initialSort.order : defaultOrder);
    if (!isFilterOpen) {
        return null;
    }
    const onSortBy = (data) => {
        removeFromCurrentSort({ filter });
        if (data.value !== null || data.order !== defaultOrder) {
            addToCurrentSort({ ...data, filter });
        }
    };
    const onInputChange = (date$1) => {
        const isDate = date.isDateValid(date$1);
        const nextFilterValue = isDate ? date$1 : null;
        setFilterValue(nextFilterValue);
        onSortBy({ value: nextFilterValue, order: sortValue });
    };
    const onRadioChange = (sortVal) => (e) => {
        setSortValue(e.target.value);
        onSortBy({ value: filterValue, order: sortVal });
    };
    return (React__default.default.createElement(filterPopin_styles.ContainerStyled, { id: id, ref: node, endColumn: endColumn, isFirstCol: isFirstCol },
        React__default.default.createElement(Small.CalendarMonthSmall, { value: filterValue, onChange: onInputChange, locale: locale, month: month, onMonthChange: setMonth, ...calendarProps }),
        React__default.default.createElement(filterPopin_styles.RowStyled, { space: "s", justifyContent: "flex-end" },
            React__default.default.createElement(component.Button, { id: `${id}-clear`, onClick: () => onInputChange(null), disabled: !filterValue }, labelClear)),
        React__default.default.createElement(filterPopin_styles.FilterDiv, null, labelOrderTitle),
        React__default.default.createElement(filterPopin_styles.FlexDiv, null,
            React__default.default.createElement(filterPopin_styles.Radio, { id: `${id}-date`, name: "filter", value: "date", checked: sortValue === 'date', onChange: onRadioChange('date') }),
            React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-date` }, labelOrderDate)),
        React__default.default.createElement(filterPopin_styles.FlexDiv, null,
            React__default.default.createElement(filterPopin_styles.Radio, { id: `${id}-asc`, name: "filter", value: "asc", checked: sortValue === 'asc', onChange: onRadioChange('asc') }),
            React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-asc` }, labelOrderAsc)),
        React__default.default.createElement(filterPopin_styles.FlexDiv, null,
            React__default.default.createElement(filterPopin_styles.Radio, { id: `${id}-desc`, name: "filter", value: "desc", checked: sortValue === 'desc', onChange: onRadioChange('desc') }),
            React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-desc` }, labelOrderDesc))));
};

exports.FilterDatePopin = FilterDatePopin;
//# sourceMappingURL=filterDatePopin.js.map
